<template>
  <div
    class="feed-filters-menu-container"
    :class="{'extra-margin': selected == 'Activities'}"
  >
    <md-card>
      <div class="md-layout feed-filter-layout">
        <md-field
          class="md-medium-size-45"
          :class="{
            'md-layout-item': true,
            'md-size-45': selected != 'Activities',
            'md-size-25': selected == 'Activities',
          }"
        >
          <md-input
            v-model="searchValue"
            placeholder="Suche"
            @keyup="search"
          />
          <i
            class="fal fa-times"
            @click="emptySearch"
          />
        </md-field>

        <div
          v-if="selected == 'Activities'"
          class="md-medium-size-45"
          :class="{'md-layout-item': true, 'feed-date-time': true, 'md-size-15': selected == 'Activities'}"
        >
          <md-field
            class="feed-date-time"
            placeholder="start"
          >
            <datetime
              v-model="start"
              type="date"
              input-class="form-control"
              placeholder="Start"
              format="dd:MM.yyyy"
            />
          </md-field>
        </div>

        <div
          v-if="selected == 'Activities'"
          class="md-medium-size-45"
          :class="{'md-layout-item': true, 'feed-date-time': true, 'md-size-15': selected == 'Activities'}"
        >
          <!--          <label>End</label>-->
          <md-field class="feed-date-time">
            <datetime
              v-model="end"
              type="date"
              input-class="form-control"
              placeholder="End"
              format="dd:MM.yyyy"
              :disabled="!start"
            />
          </md-field>
        </div>

        <md-field
          v-if="selected == 'Activities'"
          class="md-medium-size-45"
          :class="{ 'md-layout-item': true, 'md-size-15': selected == 'Activities'}"
        >
          <md-input
            v-model="selectedUsersName"
            placeholder="Freunde"
            class="friends-input"
            readonly
            @click="openFriendsModal()"
          />
        </md-field>

        <md-field
          class="md-medium-size-45"
          :class="{
            'md-layout-item': true,
            'md-size-45': selected != 'Activities',
            'md-size-25': selected == 'Activities',
          }"
        >
          <label>Show</label>
          <md-select
            v-model="selected"
            @md-selected="changes"
          >
            <md-option
              v-for="item in selections"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
              {{ item.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </md-card>

    <modal
      v-if="showFriendsModal"
      v-model="showFriendsModal"
    >
      <!-- was ??? v-model:show="showFriendsModal" -->
      <template #header>
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <span class="modal-title">Invite friends</span>
          </div>
          <div
            class="md-layout-item md-size-10"
            @click="showFriendsModal = false"
          >
            <md-icon @click="closeModal">
              close
            </md-icon>
          </div>
        </div>
      </template>
      <template #body>
        <div :class="{'friends-list': true }">
          <span>{{ areAllUsersSelected ? 'Deselect all' : 'Select all' }}</span>
          <md-checkbox
            v-model="areAllUsersSelected"
            :value="true"
            @change="selectAllFriends(areAllUsersSelected)"
          />
        </div>
        <div :class="{'friends-list': true, 'selected': isMyUserSelected }">
          <user-avatar
            class="md-layout-item md-size-60"
            :title="loggedInUser.displayName"
            :image="loggedInUser.image"
          />
          <md-checkbox
            v-model="isMyUserSelected"
            :value="loggedInUser._id"
          />
        </div>
        <div
          v-for="friend in friendsList"
          :key="friend._id"
          :class="{'friends-list': true, 'selected': selectedFriends.includes(friend._id) }"
        >
          <user-avatar
            class="md-layout-item md-size-60"
            :title="friend.displayName"
            :image="friend.image"
          />
          <md-checkbox
            v-model="selectedFriends"
            :value="friend._id"
            class="md-primary"
          />
        </div>

        <div style="width: 100%">
          <md-button
            class="md-layout-item md-size-100 md-info save-button"
            @click="emitFriendsList()"
          >
            Save
          </md-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import Modal from "./Modal";
import UserAvatar from "../atoms/user-avatar";
import 'vue-datetime/dist/vue-datetime.css'

const selectionsType = [
  {
    id: 1,
    name: 'All'
  },
  {
    id: 2,
    name: 'News'
  },
  {
    id: 3,
    name: 'Activities'
  }
]
export default {
  name: 'FeedFiltersMenu',
  components: { datetime: Datetime, Modal, UserAvatar },
  props: {
    loggedInUser: {
      type: Object,
    },
    selected: {
      type: String,
      default: 'All',
    }
  },
  data() {
    return {
      selections: selectionsType,
      showFriendsModal: false,
      searchValue: '',
      start: null,
      end: null,
      friendsList: [],
      selectedFriends: [],
      isMyUserSelected: false,
      areAllUsersSelected: false,
      selectedUsersName: null,
      selectedUsers: [],
    }
  },
  watch: {
    start(val) {
      if (val) {
        this.$emit('startDateChanged', val);
      }
    },
    end(val) {
      if (val) {
        this.$emit('endDateChanged', val);
      }
    },

    isMyUserSelected(val) {
      const allUsers = [...this.friendsList, val];
      this.areAllUsersSelected = val && this.selectedFriends.length + 1 === allUsers.length;
      if (val) {
        this.selectedUsers = [{
          _id: this.loggedInUser._id,
          displayName: this.loggedInUser.displayName
        }, ...this.selectedUsers]
      } else {
        this.selectedUsers = this.selectedUsers.filter(f => f._id !== this.loggedInUser._id);
      }
    },
    selectedFriends(val) {
      const allUsers = [...this.friendsList, this.loggedInUser._id];
      this.areAllUsersSelected = this.isMyUserSelected && val.length + 1  === allUsers.length;
      this.selectedUsers = []
      for (let i = 0; i < val.length; i++) {
        this.selectedUsers.push(this.friendsList.filter(f => f._id == val[i])[0]);
      }
      if (this.isMyUserSelected) {
        this.selectedUsers = [{_id: this.loggedInUser._id, displayName: this.loggedInUser.displayName}, ...this.selectedUsers]
      }
    },
  },
  methods: {
    changes(e) {
      this.$emit('selectionChanged', e.toLowerCase());
    },
    search(val) {
      if (val.key !== this.searchValue) {
        if (this.searchValue.length > 2) {
          this.$emit('searchChanged', this.searchValue);

        } else if (this.searchValue.length == 0) {
          this.$emit('searchChanged', '');
        }
      }
    },
    emptySearch() {
      this.searchValue = '';
      this.$emit('searchChanged', '');
    },
    openFriendsModal() {
      this.$store.dispatch("loadFriends")
          .then(res => {
            this.friendsList = res;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          })
      this.showFriendsModal = true;
    },
    closeModal() {
      this.showFriendsModal = false;
      this.selectedFriends = [];
    },
    emitFriendsList() {
      this.$emit('selectedFriendsChanged', { friendsList: this.selectedFriends, me: this.isMyUserSelected ? 1 : 0 });

      this.selectedUsersName = this.selectedUsers.map(s => s.displayName).join(', ');
      this.showFriendsModal = false;
    },
    selectAllFriends(areSelected) {
      if (areSelected) {
        this.selectedFriends = this.friendsList.map(f => f._id);
        this.isMyUserSelected = this.loggedInUser._id;
      } else {
        this.selectedFriends = [];
        this.isMyUserSelected = false;
      }
    }
  }
}
</script>

<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.css';
.feed-filters-menu-container {
  display: flex;
  align-items: center;
  height: 68px;
  .feed-filter-layout {
    display: flex;
    justify-content: space-around;
    i {
      font-size: 18px;
      margin-top: 8px;
      color: #999999;
    }
  }
  .modal-title {
    font-size: 20px;
    font-weight: 500;
  }

  .modal-body {
    padding: 24px 0 0 !important;
    overflow-y: auto;
    .friends-list {
      display: flex;
      justify-content: space-between;
      height: 56px;
      align-items: center;
      padding: 0 24px;
      &.selected {
        background: rgba(223, 38, 59, 0.08);
      }
    }
    .save-button {
      margin-bottom: 0 !important;
    }
  }
  .modal-footer {
    display: none;
  }
  .friends-input {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap
  }
}
.feed-date-time {
  padding-right: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  align-self: center;
  label {
    font-size: 12px;
    color: #aaaaaa;
  }
  .vdatetime {
    flex: 1 1 auto;
    input {
      width: 100%;
      height: 37px !important;
    }
  }
  .md-field:not(.md-disabled):after {
    height: 0;
  }
}
@media (max-width: 1280px) {
  .extra-margin {
    margin-top: 35px;
  }
}
</style>
